export default __webpack_public_path__ + "static/media/chilun.a9cb0b83.png";